const crystalblingvape = {
    id: 'crystalblingvape',
    publicSiteName: 'Crystal Bling Vape',
    branch: process.env.NEXT_PUBLIC_SHOP_BRANCH,
    siteUrl: process.env.NEXT_PUBLIC_SITE_URL,
    googleVerification: process.env.NEXT_PUBLIC_GOOGLE_SITE_VERIFICATION,
    gaId: process.env.NEXT_PUBLIC_GA_ID,
    theme: {
        colors: {
            primary: '#0069A8FF',
            secondary: '#0F172BFF',
        },
        fonts: {
            body: 'var(--font-sans)',
            heading: 'var(--font-heading)',
        },
        radius: '4px',
        header: {
            layout: 'classic',
            dark: false,
            sticky: true,
            showSearch: true,
            showAccount: true,
            showWishlist: true,
            showAnnouncementBar: true,
            transparent: false,
        }
    },
    assets: {
        favicon: '/crystalblingvape/favicon.ico',
        logo: '/crystalblingvape/logo.png',
    },
    features: {
        rewards: true,
        subscriptions: true,
    },
}

export default crystalblingvape